import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import RecreationAPI from '../serviceAPI/RecreationAPI';

const initialState = {
  recreationData: [],
  isLoading: false,
  prevThumbnailDetails: null,
  prevThumbnailId: '',
  prevRecreationImageDetails: null,
  prevRecreationIds: null,
  errorCode: null,
};

export const getAllRecreationData = createAsyncThunk(
  'getAllRecreationData',
  async (id, { rejectWithValue }) => {
    try {
      const res = await RecreationAPI.GetAllRecreationData(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const createNewRecreationData = createAsyncThunk(
  'createNewRecreationData',
  async ({ newData, id }, { rejectWithValue }) => {
    try {
      const res = await RecreationAPI.CreateNewRecreationData(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const updateRecreation = createAsyncThunk(
  'updateRecreation',
  async ({ newData, id }, { rejectWithValue }) => {
    try {
      const res = await RecreationAPI.UpdateRecreation(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const deleteRecreation = createAsyncThunk(
  'deleteRecreation',
  async (id, { rejectWithValue }) => {
    try {
      const res = await RecreationAPI.DeleteRecreation(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const updateRecreationOrder = createAsyncThunk(
  'recreation/updateRecreationOrder',
  async ({ officeId, orderedArray }, { rejectWithValue }) => {
    try {
      // orderedArray: [{ _id, name, order }, ...]
      const res = await RecreationAPI.UpdateRecreationOrder(officeId, orderedArray);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.status || 'Network Error');
    }
  }
);
const RecreationSlice = createSlice({
  name: 'refuel',
  initialState,
  reducers: {
    setPrevThumbnailDetails: (state, action) => {
      state.prevThumbnailDetails = action.payload;
    },
    setPreThumbnailId: (state, action) => {
      state.prevThumbnailId = action.payload;
    },
    setPrevRecreationImageDetails: (state, action) => {
      state.prevRecreationImageDetails = action.payload;
    },
    setPrevRecreationIds: (state, action) => {
      state.prevRecreationIds = action.payload;
    },
    resetErrorAlert: (state, action) => {
      state.errorCode = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getAllRecreationData
      .addCase(getAllRecreationData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllRecreationData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.recreationData = [...action.payload];
      })
      .addCase(getAllRecreationData.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      })

      // createNewRecreationData
      .addCase(createNewRecreationData.fulfilled, (state, action) => {
        state.recreationData.push(action.payload);
      })
      .addCase(createNewRecreationData.rejected, (state, action) => {
        state.errorCode = action.payload;
      })

      // updateRecreation
      .addCase(updateRecreation.fulfilled, (state, action) => {
        state.recreationData = state.recreationData.map((recreation) =>
          recreation._id === action.payload._id ? action.payload : recreation
        );
      })
      .addCase(updateRecreation.rejected, (state, action) => {
        state.errorCode = action.payload;
      })

      // deleteRecreation
      .addCase(deleteRecreation.fulfilled, (state, action) => {
        const id = action.payload._id;
        const index = state.recreationData.map((item) => item._id).indexOf(id);
        state.recreationData.splice(index, 1);
      })
      .addCase(deleteRecreation.rejected, (state, action) => {
        state.errorCode = action.payload;
      })

      // updateRecreationOrder
      .addCase(updateRecreationOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRecreationOrder.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateRecreationOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      });
  },
});

export const {
  setPrevThumbnailDetails,
  setPreThumbnailId,
  setPrevRecreationImageDetails,
  setPrevRecreationIds,
  resetErrorAlert,
} = RecreationSlice.actions;
export default RecreationSlice.reducer;
